import { Typography } from "@mui/material";
import { StateFieldsForm, StateFieldsFormProps } from "components/Forms/StateFieldsForm";
import { SubSection } from "components/SubSection";
import { ProgramArea } from "generated-graphql/graphql";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";

import { FacilityDetailsInput } from "./FacilityProfile";
import { useFacilityStateFields } from "./useFacility";

interface FacilityStateFieldsFormProps extends StateFieldsFormProps {
  jurisdictions?: string[];
  programArea?: ProgramArea;
}

export function FacilityStateFieldsForm(props: FacilityStateFieldsFormProps) {
  const form = useFormContext<FacilityDetailsInput>();
  const { facilityId } = useParams<{ facilityId: string }>();
  const { jurisdictions, programArea, ...rest } = props;

  const { error } = useFacilityStateFields(facilityId, jurisdictions, {
    onCompleted: (data) => {
      if (
        // if we get back an array, empty or not, set it
        data?.facilityStateFields !== undefined &&
        data?.facilityStateFields !== null
      ) {
        let fields = data.facilityStateFields;
        if (programArea === ProgramArea.Rcra) {
          fields = fields.filter((f) => f.type === ProgramArea.Rcra);
        } else if (programArea === ProgramArea.Epcra) {
          fields = fields.filter((f) => f.type !== ProgramArea.Rcra);
        }
        const mappedFields = fields.map((field) => ({
          ...field,
          value: field.value ?? null,
        }));

        form.setValue("stateFields", mappedFields);
      }
    },
  });

  if (error) return <div>Error loading state fields</div>;

  if (jurisdictions?.includes("CA")) {
    return (
      <SubSection>
        <Typography>
          Because this facility is in California, the California HMBP questions will appear in the
          facility's Tier II report in Chemicals.
        </Typography>
      </SubSection>
    );
  }

  if (props.fields?.length === 0) {
    return (
      <SubSection>
        <Typography>No additional information needed.</Typography>
      </SubSection>
    );
  } else {
    return (
      <SubSection>
        <StateFieldsForm {...rest} />
      </SubSection>
    );
  }
}
